import {AnyEvent, JOB_COMPANY_ALLOCATED_EVENT, JobCompanyAllocatedEvent} from '../type';

export default function jobCompanyAllocated(payload: JobCompanyAllocatedEvent['payload']): AnyEvent {
  return {
    type: JOB_COMPANY_ALLOCATED_EVENT,
    payload,
  }
}